// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3bO6k","imageUploader":"EGiftCard_imageUploader__4axbq"};